<template>
  <div class="page-container">
    <div class="main">
      <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div>

      <page :url="url" :form="form">
        <template slot="tableSearch">
          <el-form-item label="登录名称">
            <el-input
              v-model="form.loginName"
              placeholder="登录名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="交易日期">
            <el-col :span="11">
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择交易日期"
                v-model="form.loginStartTime"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2" style="text-align: center">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择交易日期"
                v-model="form.loginEndTime"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
          </el-form-item>
        </template>

        <template slot="tableColumn">
          <el-table-column prop="id" label="登录编号"> </el-table-column>
          <el-table-column prop="userName" label="登录所使用用户名">
          </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="systemName" label="登录系统">
          </el-table-column>
          <el-table-column
            prop="isLocked"
            label="是否登录成功"
            :formatter="$formatter.formatBoolean"
          >
          </el-table-column>
          <el-table-column
            prop="loginTime"
            label="登录时间"
            :formatter="$formatter.formatDate"
            width="200px"
          >
          </el-table-column>
          <el-table-column prop="fromIp" label="登录ip"> </el-table-column>
          <el-table-column prop="failReason" label="登录失败原因">
          </el-table-column>
        </template>
      </page>
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import UserEdit from "@/components/auth/UserEdit.vue";
import Upload from "@/components/Upload.vue";
export default {
  name: "Users",
  components: {
    "user-edit": UserEdit,
    page: Page,
    upload: Upload,
  },

  data() {
    return {
      form: {
        loginName: "",
        systemId: "",
        loginStartTime: "",
        loginEndTime: "",
      },
      url: "/loginRecord/selectList",
      systemList: [],
    };
  },

  methods: {},
  created() {},
};
</script>

<style scoped>
</style>